import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import {
  AttachMoney,
  CurrencyExchange,
  MoneyOffCsred,
} from "@mui/icons-material";
import CashAdvanceService from "../../../services/CashAdvanceService";
import { useNavigate } from "react-router-dom";
import { dateFormatter } from "../../../services/UtilsService";
import { Button, Grid, MenuItem, Pagination, Select } from "@mui/material";
import DelendLocalCentralizedCircularProgress from "../../../components/CircularProgress/DelendLocalCentralizedCircularProgress";
import InvoiceIcon from "../../../components/Vectors/InvoiceIcon";


// eslint-disable-next-line no-unused-vars
const EmptyState = ({ handleDrawerOpen }) => {
  let navigate = useNavigate();
  return (
    <React.Fragment>
      <Box
        sx={{
          padding: "100px 0px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
     <InvoiceIcon />
        <Typography
          sx={{ ml: 2, fontWeight: 600, mb: "24px" }}
          color="inherit"
          noWrap
        >
          Você ainda não possui adiantamentos na plataforma
        </Typography>

        <Typography
          width={"564px"}
          align="center"
          sx={{
            ml: 2,
            fontWeight: 400,
            color: "#8087A6",
            mb: "24px",
          }}
          color="inherit"
        >
          Olá! Para antecipar recebíveis, selecione as notas desejadas na página de vendas
        </Typography>
        <Button onClick={()=>  navigate(`/dashboard/receivable`)} variant="outlined">
          selecionar Notas Fiscais
        </Button>
      </Box>
    </React.Fragment>
  );
};

export default function EnhancedTable() {
  let navigate = useNavigate();
  const [visibleRows, setVisibleRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageQuantity, setPageQuantity] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const statusIcon = {
    FINISHED: <AttachMoney sx={{ color: "#269800", marginRight: "6px" }} />,
    IN_PROGRESS: <CurrencyExchange sx={{ color: "#FF8500", marginRight: "6px" }} />,
    OVERDUE: <MoneyOffCsred sx={{ color: "#E71D36", marginRight: "6px" }} />,
  };

  const statusLabel = {
    FINISHED: "Quitado",
    IN_PROGRESS: "Em andamento",
    OVERDUE: "Atrasado",
  };

  const headCells = [
    {
      id: "contractNumber",
      numeric: false,
      disablePadding: false,
      label: "Número do contrato",
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: "Data de criação",
    },
    {
      id: "totalValue",
      numeric: false,
      disablePadding: false,
      label: "Valor total",
    },
    {
      id: "installments",
      numeric: false,
      disablePadding: false,
      label: "Qtd. de parcelas pagas",
    },
    {
      id: "nextPayment",
      numeric: false,
      disablePadding: false,
      label: "Próximo pagamento",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Situação do contrato",
    },
  ];

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const response = await CashAdvanceService.listCashAdvance(
        rowsPerPage,
        page
      );
      setLoading(false);
      if (response.data?.cashAdvances) {
        setVisibleRows(response.data.cashAdvances)
      }
      if (response.data?.totalNumberOfPages) {
        setPageQuantity(response.data.totalNumberOfPages);
      }
    };

    fetchData();
  }, [rowsPerPage, page]);

  const handleClick = (event, uuid) => {
    event.stopPropagation();
    navigate(`/dashboard/anticipation/detail/${uuid}`);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {visibleRows.length || loading
        ?
        <Box>
        <TableContainer>
          <Table aria-labelledby="tableTitle">
            <TableHead sx={{}}>
              {headCells.map((headCell) => (
                <TableCell
                  sx={{ borderRight: "1px solid #E9EBF0", color: "#575757", fontSize: 14, fontWeight: 400 }}
                  key={headCell.id}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "normal"}
                >
                  {headCell.label}
                </TableCell>
              ))}
            </TableHead>
             <TableBody>
              { !loading &&
                visibleRows.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
  
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.uuid)}
                      key={row.contractNumber}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="left"
                        // padding="none"
                      >
                        <Typography
                          sx={{ fontWeight: 400 }}
                          color="inherit"
                          noWrap
                        >
                          {row.contractNumber}
                        </Typography>
                        <Typography
                          sx={{ fontWeight: 400, color: "#8087A6" }}
                          color="inherit"
                          noWrap
                        >
                          {row.numberOfReceivables} notas
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                      <Typography
                          sx={{ fontWeight: 400}}
                          color="inherit"
                          noWrap
                        > 
                         {dateFormatter(row.createdAt)}
                        </Typography>
                      
                      </TableCell>
                      <TableCell align="left">
                        <Typography
                          sx={{ fontWeight: 400 }}
                          color="inherit"
                          noWrap
                        >
                          {row.contractTerms
                            ? Number(
                                row.contractTerms.totalCreditAmount
                              ).toLocaleString("pt-br", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : ""}
                        </Typography>
                        <Typography
                          sx={{ fontWeight: 400, color: "#8087A6" }}
                          color="inherit"
                          noWrap
                        >
                          {row.installments}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography
                          sx={{ fontWeight: 400 }}
                          color="inherit"
                          noWrap
                        >
                          {row.numberOfPaidInstallments}/
                          {row.totalNumberOfInstallments}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        {dateFormatter(row.nextBillingAt)}
                      </TableCell>
                      <TableCell align="left">
                        {statusIcon[row.contratStatus]}{" "}
                        {statusLabel[row.contratStatus]}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        {loading && (
          <Box>
            <DelendLocalCentralizedCircularProgress />
          </Box>
        )}
        <Box sx={{ width: "100%" }} align="right">
          <Grid sx={{ width: "100%" }} container justifyContent="flex-end">
            <Grid>
              Itens por página
              <Select
                sx={{
                  boxShadow: "none",
                  ".MuiOutlinedInput-notchedOutline": { border: 0 },
                }}
                value={rowsPerPage}
                label="RowsPerPage"
                onChange={handleChangeRowsPerPage}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
              </Select>
            </Grid>
            <Grid>
              <Pagination
                sx={{ paddingTop: "12px" }}
                rowsPerPageOptions={[5,10,25]}
                disabled={loading}
                count={pageQuantity}
                onChange={(event, page) => setPage(page)}
              />
            </Grid>
          </Grid>
        </Box>
        </Box>
        : !loading &&
        <EmptyState/>
      }
    </Box>
  );
}
